module.exports = __webpack_public_path__ + "img/img-16.385218b6.jpeg";